module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-640x360-8205cf4f23158e0332e915823e56bc8f.webp";